/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from '@jutro/locale';

export default defineMessages({
    viewAllClaims: {
        id: 'ml.gateway.views.ActivityReports.MLClaimsReportComponent.VIEW ALL CLAIMS',
        defaultMessage: 'VIEW ALL CLAIMS'
    },
    noRecentClaimActivityFound: {
        id: 'ml.gateway.views.ActivityReports.MLClaimsReportComponent.No recent claim activity found',
        defaultMessage: 'No recent claim activity found'
    },
    dateOfLoss: {
        id: 'ml.gateway.views.ActivityReports.MLClaimsReportComponent.DATE OF LOSS',
        defaultMessage: 'DATE OF LOSS'
    },
    customerName: {
        id: 'ml.gateway.views.ActivityReports.MLClaimsReportComponent.CUSTOMER NAME',
        defaultMessage: 'CUSTOMER NAME'
    },
    product: {
        id: 'ml.gateway.views.ActivityReports.MLClaimsReportComponent.PRODUCT',
        defaultMessage: 'PRODUCT'
    },
    policy: {
        id: 'ml.gateway.views.ActivityReports.MLClaimsReportComponent.POLICY #',
        defaultMessage: 'POLICY #'
    },
    claim: {
        id: 'ml.gateway.views.ActivityReports.MLClaimsReportComponent.CLAIM #',
        defaultMessage: 'CLAIM #'
    },
    status: {
        id: 'ml.gateway.views.ActivityReports.MLClaimsReportComponent.STATUS',
        defaultMessage: 'STATUS'
    },
    loading: {
        id: 'ml.gateway.views.ActivityReports.MLClaimsReportComponent.Loading...',
        defaultMessage: 'Loading...'
    },
    claims: {
        id: 'ml.gateway.views.ActivityReports.MLClaimsReportComponent.Claims...',
        defaultMessage: 'Claims...'
    }
});
